import GetMerchantInfo from "../symbols/getMerchantInfo";

export interface IMerchantInfo {
    Id: string;
    Email: string;
    Phone: string;
    Name: string;
    AddressLine1: string | undefined;
    AddressLine2: string | undefined;
    AddressLine3: string | undefined;
    PostalCode: string | undefined;
    County:  string | undefined;
    City: string | undefined;
}
interface IState {
  data: IMerchantInfo[];
  loading: boolean;
  error: boolean;
}
const initialState: IState = {
  data: [],
  loading: false,
  error: false,
};

export default function GetMerchantInfoReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case GetMerchantInfo.GET_MERCHANT_INFO:
      return { ...state, loading: true, error: false };
    case GetMerchantInfo.GET_MERCHANT_INFO_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case GetMerchantInfo.GET_MERCHANT_INFO_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case GetMerchantInfo.CLEAR_GET_MERCHANT_INFO:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
